import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Dropdown, Menu, Space, Select, Divider, Tooltip, Button, Badge, App, Avatar } from 'antd';
import { DownOutlined, UserOutlined, TeamOutlined, BellTwoTone } from '@ant-design/icons';
import { langChange, optionalCountryChange } from '@/app/reducers/headerSlice';
import NoticeList from '@/component/notice';
import Password from "@/component/password";
import { STATIC_RESOURCE } from '@/utils/tools';
import useCustomStoreHooks from '@/hooks/useStore';
import { userSwitchCompanys } from '@/utils/api/common';
import './index.less';

const langOptions = [{ label: '简体中文', value: 'zh' }, { label: 'English', value: 'en' }];
export default function Index() {
  const { message } = App.useApp();
  const { store, translate } = useCustomStoreHooks();
  const navigate = useNavigate(), location = useLocation(), dispatch = useDispatch();
  const { country: { value: country }, lang: { value: language, optionalCountryId, currency, saleCountry } } = store;
  const $t = (key) => translate({ translate_language_key: 'component.header.language', key });
  const [companyRole, setCompanyRole] = useState();
  const [passModal, setPassModal] = useState(Boolean);
  const [countryOpen, setCountryOpen] = useState(Boolean);
  const [langOpen, setLangOpen] = useState(Boolean);
  const [noticeOpen, setNoticeOpen] = useState(Boolean);
  const [countryId, setCountryId] = useState(optionalCountryId);
  const [roleText, setRoleText] = useState($t('Supplier Center'));
  const [LangAndCurrency, setLangAndCurrency] = useState({ language, currency });
  const token = window.localStorage.getItem('token');
  const { username = '', company_id = '', level, is_system } = JSON.parse(window.localStorage.getItem('user_info') || '{}');
  const { company_name = '-' } = JSON.parse(window.localStorage.getItem('company_info') || '{}');
  const [buyerCompanyId, setBuyerCompanyId] = useState(company_id ? '1' : '');
  const { cart: { list: cartList = [] }, notice: { list: noticeList }, company: { list: companyList } } = useSelector(state => state);
  const unreadMessageNumber = noticeList.filter(item => !item.is_read).length;
  const formatList = cartList.reduce((prev, next) => [...prev, ...next.sale_list], []).length;
  const supplierItemsIcon = <><img src={`${STATIC_RESOURCE}/cp_gsp/header/workoutlined.png`} width={20} height={20} alt={``} /></>;
  const currencyOptions = [{ label: $t('CNY-RMB'), value: 'CNY' }, { label: 'USD-US Dollar', value: 'USD' }];
  const baseCountryOptionsRender = (option) => (<span style={{ display: 'flex', alignItems: 'center' }}><Avatar size="small" shape="square" style={{ borderRadius: 0, width: 22, height: 16, marginRight: 5 }} icon={<img src={country.find(item => `${item.id}` === `${option.value}`)?.icon} alt='' />} />{option.label}</span>);
  const supplierItems = [
    { label: '', key: 'mail', icon: supplierItemsIcon, children: [{ key: 'supplier', label: `${roleText}`, condition: 1 }, { key: 'buyers', label: $t('Buyer Center'), condition: buyerCompanyId },].filter(item => item.condition) }
  ];

  const onLanguageChange = (language) => {
    setLangAndCurrency(pre => ({ ...pre, language }));
  };
  const onCurrencyChange = (currency) => {
    setLangAndCurrency(pre => ({ ...pre, currency }));
  };
  const handleClickCountryAndLang = () => {
    dispatch(langChange(LangAndCurrency));
    setLangOpen(false);
    window.location.reload(); // 刷新页面
  };
  const onOpenLang = (open) => {
    setLangOpen(open);
  };

  const onOpenChange = () => {
    getCompanyRole();
  };

  const switchCompanyItem = companyList?.length === 0 ? undefined : {
    key: '4', label: (<span>{$t('Switch company')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/exchange_account.png`} width={20} height={20} alt={``} />,
    children: companyList.map(item => ({ key: `${item.id}`, label: item.name, condition: 1 }))
  };
  const items = [
    { key: '1', label: (<span>{$t('Company Management')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/company_manage.png`} width={20} height={20} alt={``} /> },
    switchCompanyItem,
    { key: '2', label: (<span>{$t('Change Password')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/modify_password.png`} width={20} height={20} alt={``} /> },
    { key: '3', label: (<span>{$t('Log out')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/logout.png`} width={20} height={20} alt={``} /> },
  ].filter(item => item);

  const toggleNoticeOpen = () => {
    setNoticeOpen(noticeOpen => !noticeOpen);
  };

  const onClickMenu = (e) => {
    const { key } = e;
    // menu 入口
    // 无公司user_info.company_id === 0  0 申请
    // 有公司未申请供应商：(company_role & 1) === 0 && supplier_is_examine === 2 companyRole === 2 申请
    // 有公司已申请供应商 - 待审核：(company_role & 1) === 0 && supplier_is_examine === 1 companyRole === 3 待审核
    // 有公司已申请供应商 - 审核未通过：(company_role & 1) === 0 && supplier_is_examine === 3 companyRole === 4 待审核
    // 有公司正式供应商：(company_role & 1) === 1 companyRole === 1 去中心
    // 有公司且是采购商，不是供应商 company_role === 2 companyRole === 5 申请
    if (key === 'supplier') {
      if ([0, 2, 5, 3, 4].includes(companyRole)) {
        if ([3, 4].includes(companyRole)) {
          setRoleText($t('Check the progress of application'));
        } else {
          setRoleText($t('Apply to be a Supplier'));
        }
        navigate('/supplier/apply');
      } else if (companyRole === 1) {
        setRoleText($t('Supplier Center'));
        // navigate('/supplier/list');
        // navigate('/buyers/main');
        navigate('/supplier/front');
      } else { }
    } else if (key === 'buyers') {
      navigate('/buyers/front');
      // navigate('/buyers/index');
    } else {
      navigate(key);
    }
  };
  useEffect(() => {
    if (!window.localStorage.getItem('token')) return;
    getCompanyRole();
  });

  const getCompanyRole = () => {
    const user_info = JSON.parse(window.localStorage.getItem('user_info') || '{}');
    const company_info = JSON.parse(window.localStorage.getItem('company_info') || '{}');

    // let value = company_info.company_role & 1;
    // let supplier_is_examine = company_info.supplier_is_examine;
    // let roleType = (value === 1) ? 1 : 2;
    if (user_info.company_id === 0) { // 0 没公司 申请
      setCompanyRole(0);
      setRoleText($t('Apply to be a Supplier'));
    } else {
      // 有公司，看是否是供应商
      let value = company_info?.company_role & 1;
      let supplier_is_examine = company_info?.supplier_is_examine;
      let roleType = (value === 1) ? 1 : 2;
      setBuyerCompanyId(() => company_info?.company_role === 1 ? '' : `${company_info?.company_id}`);
      // 不是供应商
      if (roleType === 2) {
        // if (company_info.company_role === 2) {
        //   // 只有采购商
        //   setCompanyRole(5);
        // } else {
        if ([1, 4].includes(supplier_is_examine)) {
          // 审批中
          setCompanyRole(3);
          setRoleText($t('Check the progress of application'));
        } else if (supplier_is_examine === 3) {
          // 拒绝
          setCompanyRole(4);
          setRoleText($t('Check the progress of application'));
        } else if (supplier_is_examine === 2) {
          // 新申请
          // setCompanyRole(2);
          // setRoleText('申请成为供应商');

          // 是采购商新申请
          if (company_info.company_role === 2) { // 是采购商，要回显
            setCompanyRole(5);
            // const supplierApplyInfo = await getSupplierApplyInfo();
            // return supplierApplyInfo;
          } else {
            // 新申请
            setCompanyRole(2);
            // setRoleText($t('Apply to be a Supplier'));
          }
          setRoleText($t('Apply to be a Supplier'));
        }
        // }
      } else if (roleType === 1) {
        // 是供应商
        setCompanyRole(1);
        setRoleText($t('Supplier Center'));
        // 已申请并审批过(已生成供应商id)，该情况不会进入该页面，进入供应商中心页
        // console.log('您已经是供应商');
      } else { }

    }
  };
  const closePassModal = () => {
    setPassModal(false);
  };

  const onDropdownClick = async ({ key }) => {
    if (key === '1') {
      navigate(company_id ? '/company/info' : '/apply');
    } else if (key === '2') {
      setPassModal(true);
    } else if (key === '3') {
      const { pathname, search } = location;
      localStorage.clear();
      navigate(`/login?redirect=${pathname}${search}`, { replace: true });
    } else {
      const { data: { data: { company_info, token, user_info }, code }, } = await userSwitchCompanys({ switch_company_id: key });
      if (+code === 0) {
        localStorage.setItem('company_info', JSON.stringify(company_info));
        localStorage.setItem('token', token);
        localStorage.setItem('user_info', JSON.stringify(user_info));
        localStorage.setItem('user_id', user_info.id);
        // navigate('/home', { replace: true });
        window.location.href = '/home';
      }
    }
  };
  const relatedApplicationsItems = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img style={{ width: 62, height: 62, margin: 'auto' }} src={`${STATIC_RESOURCE}/cp_gsp/header/minilogo.png`} alt={$t('CP GSP mini program')} />
          <div style={{ marginTop: 6, }}>{$t('CP GSP mini program')}</div>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img style={{ width: 62, height: 62, margin: 'auto' }} src={`${STATIC_RESOURCE}/cp_gsp/home/CPQualityInspection.jpg`} alt={$t('CP Quality Inspection')} />
          <div style={{ marginTop: 6, }}>{$t('CP Quality Inspection')}</div>
        </div>
      ),
    },
  ];
  const handleOnOptionalCountry = (country) => {
    setCountryId(country);
  };

  const handleClickCountry = () => {
    if (saleCountry?.length) {// 商品可销往国家判断
      const saleCountryInfo = saleCountry.find(item => +item.id === +countryId);
      if (!saleCountryInfo) {
        return message.info('当前商品可销往国家为' + saleCountry.map(item => item.name));
      }
    }
    dispatch(optionalCountryChange(countryId));
    setCountryOpen(false);
  };
  const relatedCountryItems = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} onClick={e => e.stopPropagation()}>
          <Select value={+countryId} style={{ width: 180, margin: '10px auto', }} onChange={handleOnOptionalCountry} options={country} fieldNames={{ label: 'name', value: 'id' }} labelRender={baseCountryOptionsRender} optionRender={baseCountryOptionsRender} />
          <Button type='primary' block onClick={handleClickCountry}>{$t('save')}</Button>
        </div>
      )
    }
  ];
  const relatedLangItems = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} onClick={e => e.stopPropagation()}>
          <div style={{ alignSelf: 'flex-start' }}>{$t('Language')}</div>
          <Select value={LangAndCurrency.language} style={{ width: 170, margin: '10px auto', }} onChange={onLanguageChange} options={langOptions} />
          <div style={{ alignSelf: 'flex-start' }}>{$t('Currency')}</div>
          <Select value={LangAndCurrency.currency} style={{ width: 170, margin: '10px auto', }} onChange={onCurrencyChange} options={currencyOptions} />
          <Button type='primary' block onClick={handleClickCountryAndLang}>{$t('save')}</Button>
        </div>
      )
    }
  ];
  const onOpenCountry = (open) => {
    if (['/plan/submit', '/cart/submit'].includes(location.pathname)) {
      message.info('结算页不允许修改');
    } else {
      setCountryId(optionalCountryId);
      setCountryOpen(open);
    }
  };

  return <div className='page-header'>
    <div className='page-header-content'>
      <div className='page-header_left'>
        <Link to='/home'><div className='logo'></div></Link>
        {
          token ? <>
            {
              !['/login', '/register', '/retrieve'].includes(location.pathname) && <Dropdown menu={{ items, onClick: onDropdownClick }} destroyOnHidden trigger={['hover']}>
                <Space>
                  <span className='header-left_title'>
                    <div>
                      <Tooltip title={company_name}>{company_name}</Tooltip>
                    </div>
                    <div>
                      <Tooltip title={$t('Administrators')}>{+level === 2 ? <UserOutlined style={{ color: '#d60505' }} /> : ''}</Tooltip>
                      <Tooltip title={$t('Agency Operations')}>{+is_system === 1 ? <TeamOutlined style={{ color: '#d60505' }} /> : ''}</Tooltip>
                      <Tooltip title={username}>{username.slice(0, 10)}</Tooltip>
                    </div>
                  </span>
                  <DownOutlined />
                </Space>
              </Dropdown>
            }
          </> : null
        }
      </div>

      <Space split={<Divider type='vertical' />} className='page-header_right'>
        {
          [
            {
              element: <div className='page-header_menu'>
                <Menu triggerSubMenuAction="hover" onClick={onClickMenu} mode="horizontal" overflowedIndicator={supplierItemsIcon} items={supplierItems} onOpenChange={onOpenChange} style={{ marginRight: 30, marginTop: '-2px' }} />
                <div><Link title={$t('Allocation Center')} to='/allocations/center' className='flex-align-center'><img src={STATIC_RESOURCE + '/cp_gsp/allocations/allocation.png'} width={20} height={20} alt='' /></Link></div>
                <div><Link title={$t('Cart')} to='/cart'><Badge style={{ transform: 'scale(.85)', padding: '0 2px' }} count={formatList || 0} size='small' offset={[6, -3]} className='flex-align-center'><img src={STATIC_RESOURCE + '/cp_gsp/header/shop.png'} width={20} height={20} alt='' /></Badge></Link></div>
                <div><Link title={$t('Collect List')} to='/favorites' className='flex-align-center'><img src={STATIC_RESOURCE + '/cp_gsp/header/plan.png'} width={20} height={20} alt='' /></Link></div>
                <div><Link title={$t('Message Center')} onClick={toggleNoticeOpen}><Badge style={{ transform: 'scale(.85)', padding: '0 2px' }} count={unreadMessageNumber || 0} size='small' offset={[6, -3]} className='flex-align-center'><BellTwoTone style={{ fontSize: 21, }} twoToneColor='#000' /></Badge></Link></div>
              </div>,
              show: token && !['/login', '/register', '/retrieve'].includes(location.pathname)
            },
            {
              element: <Dropdown open={langOpen} onOpenChange={onOpenLang} trigger={['click']} destroyOnClose={true} className='header-dropdown-cursor' menu={{ items: relatedLangItems }} ><span target="_blank" rel="" onClick={(e) => e.stopPropagation()}><Space>{langOptions.find(item => item.value === language)?.label}-{currency}<DownOutlined /></Space></span></Dropdown>,
              show: true
            },
            {
              element: <Dropdown open={countryOpen} onOpenChange={onOpenCountry} trigger={['click']} destroyOnClose={true} className='header-dropdown-cursor' menu={{ items: relatedCountryItems }} ><span target="_blank" rel="" onClick={(e) => e.stopPropagation()}><Space>{$t('Ship to')}<Avatar size="small" shape="square" style={{ borderRadius: 0, width: 22, height: 16, marginRight: 5 }} icon={<img src={country.find(item => `${item.id}` === `${optionalCountryId}`)?.icon} alt='' />} /><DownOutlined /></Space></span></Dropdown>,
              show: token
            },
            {
              element: <Dropdown menu={{ items: relatedApplicationsItems, }} className='header-dropdown-cursor' ><span target="_blank" rel="" onClick={(e) => e.stopPropagation()}><Space>{$t('Related Applications')}<DownOutlined /></Space></span></Dropdown>,
              show: token && !['/login', '/register', '/retrieve'].includes(location.pathname)
            },].filter(item => item.show).map((item, index) => <div key={index} >{item.element}</div>)
        }
      </Space>
    </div>
    {passModal ? (<Password closePassModal={closePassModal} />) : ""}
    <NoticeList list={noticeList} dispatch={dispatch} open={noticeOpen} navigate={navigate} toggleNoticeOpen={toggleNoticeOpen} />
  </div >;
};
